import { memo } from 'react'

import { Icons } from 'atoms'
import { LinearGradient } from 'expo-linear-gradient'
import { Box, Button, Heading, HStack, Image, Link, Text, useTheme, VStack } from 'native-base'
import Layouts from 'organisms/Layouts'

import { ResponsiveEntryScreenComponent } from './EntryScreen.types'
import Appconfig from '../../../app.config'

const EntryScreenDesktop: ResponsiveEntryScreenComponent = memo(
  ({ goToCreateAccountCPFScreen, goToLoginScreen }) => {
    const theme = useTheme()

    return (
      <Box flex={1} position="relative" overflow="hidden">
        <LinearGradient
          colors={[
            theme.colors['header-gradient'][50],
            theme.colors['header-gradient'][100],
            theme.colors['header-gradient'][200]
          ]}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            flex: 1
          }}>
          <Layouts.ExternalDesktop
            image={require('assets/external-layout-image.png')}
            maxW="624px"
            bgColor="transparent">
            <VStack h="full" justifyContent="space-between">
              <VStack flex={1} space={6} justifyContent="center">
                <Box>
                  <Icons.LogoTurbo size={195} />
                </Box>

                <Heading
                  color="white"
                  fontSize="32px"
                  fontWeight="bold"
                  lineHeight="40px"
                  maxW="70%">
                  Chegou a hora de turbinar as nossas ferramentas.
                </Heading>

                <HStack space={6}>
                  <Button
                    flex={1}
                    maxWidth="214px"
                    variant="outline"
                    _text={{ color: 'white' }}
                    _hover={{
                      bg: 'none',
                      opacity: 0.4
                    }}
                    testID="start-page-create-user"
                    onPress={goToCreateAccountCPFScreen}>
                    Criar conta
                  </Button>

                  <Button
                    testID="start-page-get-in"
                    flex={1}
                    onPress={goToLoginScreen}
                    maxWidth="214px"
                    colorScheme="red"
                    bg="red.500">
                    Entrar
                  </Button>
                </HStack>

                <Text fontSize="16px" color="white" lineHeight="24px" maxW="70%" mt={4}>
                  Atue com eficiência e visão estratégica, acompanhe o seu cliente diariamente e
                  aumente os seus ganhos.
                </Text>
                <Text fontSize="16px" color="white" lineHeight="24px">
                  Baixe o APP e acelere suas vendas agora!
                </Text>
                <HStack>
                  <Link
                    href="https://play.google.com/store/apps/details?id=com.webmotors.consultormaisturbo&hl=pt_BR&gl=US"
                    mr={6}
                    testID="start-page-download-android"
                    isExternal>
                    <Image
                      source={require('assets/googleplay.png')}
                      w="140px"
                      h="50px"
                      resizeMode="contain"
                    />
                  </Link>
                  <Link
                    testID="start-page-download-ios"
                    href="https://apps.apple.com/br/app/consultor-mais-turbo/id1671043967"
                    isExternal>
                    <Image
                      source={require('assets/appstore.png')}
                      w="140px"
                      h="50px"
                      resizeMode="contain"
                    />
                  </Link>
                </HStack>
              </VStack>
              <Box py={6}>
                <Text color="white" fontSize="14px">
                  Modelo Comercial{' '}
                  <Text color="white" fontFamily="OpenSans_700Bold">
                    {`Turbo v.${Appconfig.version} 2023`}{' '}
                  </Text>
                </Text>
              </Box>
            </VStack>
          </Layouts.ExternalDesktop>
        </LinearGradient>
      </Box>
    )
  }
)

export default EntryScreenDesktop
